var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",attrs:{"id":"confirmRefreshModal","title":"Bevestig"}})}
var staticRenderFns = []

export { render, staticRenderFns }